import Icon from '../components/Icon.vue'

Icon.register({
  'quote-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 256c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-128c-26.5 0-48-21.5-48-48v-240c0-88.4 71.6-160 160-160h8c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-8c-35.3 0-64 28.7-64 64v64h80zM176 256c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-128c-26.5 0-48-21.5-48-48v-240c0-88.4 71.6-160 160-160h8c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-8c-35.3 0-64 28.7-64 64v64h80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/quote-left.js
// module id = 1672
// module chunks = 0